// Do this only for webforms.
const forms = document.querySelectorAll(
  '.webform-submission-form, .user-login-form',
);
const inputsSelector =
  'input:not([type="checkbox"]):not([type="hidden"]), select, textarea';
const floatingClass = 'floating';

const initFloatingLabels = (element) => {
  const label = element.nextElementSibling;
  if (label) {
    // If the input is already filled, float the label.
    if (element.value) {
      label.classList.add(floatingClass);
    }
    element.addEventListener('focus', () => {
      label.classList.add(floatingClass);
    });
    element.addEventListener('blur', () => {
      if (!element.value) {
        label.classList.remove(floatingClass);
      }
    });

    // In some browsers, typing in autofilled inputs doesn't trigger the focus event.
    element.addEventListener('input', () => {
      if (!label.classList.contains(floatingClass)) {
        label.classList.add(floatingClass);
      }
    });
  }
};

((Drupal) => {
  if (forms.length) {
    forms.forEach((form) => {
      const inputs = form.querySelectorAll(inputsSelector);
      inputs.forEach((input) => {
        initFloatingLabels(input);
      });
    });

    // Handle some things after AJAX form submit.
    Drupal.behaviors.formMessageClose = {
      attach(context) {
        if (context?.classList?.contains('webform-submission-form')) {
          // Re-init floating labels for the newly inserted inputs.
          const inputs = context.querySelectorAll(inputsSelector);
          inputs.forEach((input) => {
            initFloatingLabels(input);
          });

          // A neat way to add some offset to the AJAX scroll to top.
          if (Drupal.webform) {
            Drupal.webform.scrollTopOffset = 120;
          }

          const message = context.querySelector('[data-drupal-messages]');

          // Making the message closeable.
          if (message) {
            message.addEventListener('click', () => {
              message.remove();
            });
          }
        }
      },
    };
  }
})(Drupal);
